<template>
  <div class="progress">
    <div class="progress-title" v-if="type===1">
      请按阶段存储工程文件
    </div>
    <div class="flex flex-column justify-center align-center">
      <template v-for="(value, index) of dataArr">
        <template v-if="activeTab!==value.key">
          <div @click="emitHandle(value.key)" class="quara item cursor-pointer" :class="value.val === 0? 'disable' : ''"></div>
          <div @click="emitHandle(value.key)"  class="name item cursor-pointer">{{value.key}}</div>
        </template>
        <template v-else>
          <div style="position:relative;width: 150px; text-align: center;">
            <w-button type="primary" round size='medium'>{{value.key}}</w-button>
            <span v-if="!searchAll" class="arrow-active"></span>
          </div>
        </template>
        <img v-if="index !== dataArr.length - 1" class="arrow item" src="@/assets/images/arrow.png" alt="箭头" />
      </template>
      <div class="prj-files-tips" v-show="showPrjTips && type === 1">
        <span class="triangle"></span>
        <span class="rectangle">
          <i class="r2-icon-Click"></i>
          <span>点击这里切换项目阶段</span>
          <i class="r2-icon-nav_close prj-tips-i"  @click.stop = "closeTips"></i>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import api from 'service'
export default {
  name: 'Progress',
  props: {
    type: {
      type: Number,
      default: 0
    },
    hasTxt: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: {}
    },
    activeTab: {
      type: String,
      default: ''
    },
    searchAll: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dataArr: function (){
      console.log(this.data)
      let array = Object.keys(this.data).map(val => ({
        key: val,
        val: this.data[val]
      }))
      console.log(array)
      return array
    }
  },
  watch: {
    activeTab (){

    }
  },
  data () {
    return {
      showPrjTips: false // 是否展示引导提示
    }
  },
  mounted () {
    this.initTips()
  },
  methods: {
    emitHandle (index){
      this.$emit('statusHandle', index)
    },
    closeTips (){
      this.showPrjTips = false
      api.common.setTips('PRJTIPS').then(res => {
        if (res.code === 200) {
          console.log('PRJTIPS_close')
        }
      })
    },
    initTips (){
      api.common.getTips().then(res => {
        if (res.code === 200) {
          let data = res.data || {}
          this.showPrjTips = !data.PRJTIPS
        }
      })
    }
  }
}
</script>
<style lang="less" type="text/less">
  .progress{
    padding-right: 15px;
    padding-top: 12px;
    .item{
      margin: 5px 0;
      font-size: 14px;
      font-weight: 500;
    }
    .progress-title{
      text-align: center;
      margin-bottom: 13px;
      font-size: 12px;
      margin-left: 15px;
    }
    .quara{
      background: #2079FA;
      width: 16px;
      height: 16px;
      transform: rotate(45deg);
      &.disable{
        background: rgba(33,37,48,0.35);
      }
    }
    .arrow{
      width: 9px;
      height: 33px;
    }
    .w__button>span{
      height: unset;
    }
    .arrow-active{
      position: absolute;
      right: -8px;
      top: 7px;
      content: '';
      width: 0;
      height: 0;
      border-top: 13px solid transparent;
      border-right: 13px solid rgba(33, 37, 48, 0.15);
      border-bottom: 13px solid transparent;
      border-left: 13px solid transparent;
      &::after{
        width: 0;
        height: 0;
        border-top: 13px solid transparent;
        border-right: 13px solid #fff;
        border-bottom: 13px solid transparent;
        border-left: 13px solid transparent;
        position: absolute;
        left: -11px;
        top: -13px;
        display: block;
        clear: both;
        content: "";
      }
    }
  }
  .prj-status-container {
    &:hover {
      .prj-files-tips {
        display: block;
      }
    }
  }
  .prj-files-tips{
    display: none;
    position: relative;
    left: -48px;
    bottom: -126px;
    animation: dialog-fade-in .3s;
    .rectangle{
      position: absolute;
      z-index: 10;
      bottom: 0;
      left: 0;
      width: 268px;
      height: 74px;
      line-height: 74px;
      background: rgba(32,121,250,1);
      box-shadow: 0px 2px 8px 0px rgba(33,37,48,0.15);
      border-radius: 4px;
      span{
        margin-left:16px;
        font-size:16px;
        font-weight:400;
        color:rgba(255,255,255,1);
      }
      &>i{
        margin-left:20px;
        font-size: 32px;
        color:rgba(255,255,255,1);
      }
      .prj-tips-i{
        position: absolute;
        font-size: 20px;
        width: 20px;
        height: 20px;
        line-height: 20px;
        right: 8px;
        top: 8px;
        color:rgba(255,255,255,0.55);
        cursor: pointer;
      }
    }
    .triangle{
      position: absolute;
      bottom: 74px;
      left: 38px;
      content: '';
      width: 0;
      height: 0;
      border-top: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid rgba(32,121,250,1);
      border-left: 10px solid transparent;
    }
  }
</style>
